exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-pricing-detail-form{display:grid;grid-template-columns:1fr 1fr;gap:2rem}.product-pricing-detail-form__left{display:flex;flex-direction:column;gap:1.5rem;z-index:11}.product-pricing-detail-form__right .equal-price-alert{margin-top:1rem}.product-pricing-detail-form__variation-values{display:flex;flex-direction:row;gap:1.5rem}.product-pricing-detail-form__variation-values>label{max-width:148px}.product-pricing-detail-form__price-settings{display:flex;flex-direction:row;gap:2.5rem;padding-bottom:1rem}.product-pricing-detail-form__charm-pricing{display:flex;align-items:flex-end}", ""]);

// exports
